import { useParams } from "react-router-dom";
import Note from "./Note";
import SuggestionsBlock from "components/SuggestionsBlock";
import { t } from "i18next";
import { useApplyForMajor, useGetApplication } from "api/application";
import Loader from "components/Loader";
import Applied from "./Applied";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import ApplicationForm from "./ApplicationForm";
import RenderURL from "./RenderURL";
import { useModal } from "context/hooks/useModal";
import ReportProblem from "pages/Block/ReportProblem";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

const Apply = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetApplication(id);
  const { mutate: applyForMajor, isPending: applyingForMajor } =
    useApplyForMajor();
  const {
    lifeChoice: { application_form = null },
  } = useLifeChoicePageContext();
  const { showModal } = useModal();
  const { language } = useAppSelector(getSettings);

  const renderApplicationForm = () => {
    if (application_form && application_form.type === "form") {
      return (
        <ApplicationForm
          applicationForm={application_form}
          onsubmit={(applicationFormDetails) => {
            applyForMajor({
              major: id,
              applicationFormDetails,
              language,
            });
            if (application_form?.link) {
              showModal(<RenderURL url={application_form.link} />, "xl");
            }
          }}
        />
      );
    } else if (application_form && application_form.type === "instant") {
      return (
        <Note
          title={application_form.details.title}
          description={application_form.details.description}
          buttonText={application_form.details.buttonText}
          onClick={() => {
            applyForMajor({
              major: id,
              time: new Date(),
              language,
            });
            if (application_form.details?.link) {
              showModal(
                <RenderURL url={application_form.details.link} />,
                "xl"
              );
            }
          }}
        />
      );
    } else {
      return (
        <Note
          title={t("applyTabCongratsTitle")}
          description={t("applyTabCongratsText")}
          buttonText={t("applyNowButton")}
          onClick={() => {
            applyForMajor({
              major: id,
              time: new Date(),
              language,
            });
          }}
        />
      );
    }
  };

  return (
    <>
      {data ? (
        <Applied />
      ) : (
        <div className="relative">
          <Loader open={isLoading || applyingForMajor} type="block" />
          {renderApplicationForm()}
        </div>
      )}
      <div className="container flex">
        <ReportProblem className="-mb-2 mt-4 mx-auto" />
      </div>
      <SuggestionsBlock />
    </>
  );
};

export default Apply;
